module.exports = __webpack_public_path__ + "media/images/task-icon-grey-377d61ba72f58c5a01a7c23c875a1392.svg";